import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "text-center flex-1 flex flex-col",
  "data-aos": "fade-down"
}
const _hoisted_2 = { class: "flex-1 flex flex-col p-4 lg:p-0 lg:w-1/4 mx-auto flex flex-col space-y-3 justify-center" }
const _hoisted_3 = { class: "text-4xl font-bold text-palette1 mb-4" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("flashi ")
const _hoisted_5 = {
  key: 1,
  class: "flex flex-col space-y-3"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-2xl font-bold text-palette3 py-2" }, "sign in", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" and use the tool for "),
  /*#__PURE__*/_createElementVNode("strong", { class: "text-palette5 text-2xl px-2" }, "free")
], -1)
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "py-4" }, null, -1)
const _hoisted_10 = { class: "text-left pl-3" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("email ")
const _hoisted_12 = { class: "text-left pl-3" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("password ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("login")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("create account")
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, "or", -1)
const _hoisted_17 = { class: "flex justify-center space-x-2 items-center" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, "sign in with Google", -1)

import Loading from "../components/Loading.vue";
import MyButton from "../components/MyButton.vue";
import MyInput from "../components/MyInput.vue";
import { post } from "../server";

import firebase from "firebase/app";
import "firebase/auth";
import { computed, onMounted, ref } from "vue";
import { store } from "@/store";
import { gtag } from "@/gtag";
import { router } from "@/router";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const email = ref("");
const password = ref("");
const wait = ref(false);
const error = ref("");

const errorHtml = computed(() => error.value.split("\n").join("<br/>"));

onMounted(() => {
  gtag.event("page:login");
  loadFirebase();
  // go to login page conversion
  gtag.event("conversion", {
    send_to: `AW-967082918/v4KHCLyok5QDEKaHks0D`,
  });
});

function loadFirebase() {
  //only once
  if (store.state.isFirebaseReady) return;

  const firebaseConfig = {
    apiKey: "AIzaSyBUmFJq4K5Aro1sVF_i-ivXxUABe34Hofg",

    // authDomain: "easy-flashcards-334211.firebaseapp.com",
    authDomain: "auth.flashi.app",

    projectId: "easy-flashcards-334211",

    storageBucket: "easy-flashcards-334211.appspot.com",

    messagingSenderId: "1052780870133",

    appId: "1:1052780870133:web:15dc369d4dd0ace8ff48bc",

    measurementId: "G-DJ4LRN8FBH",
  };
  firebase.initializeApp(firebaseConfig);
  console.log("firebase loaded!");
  store.commit("firebaseReady");
}

async function createAccount() {
  if (isDisabled.value) {
    error.value =
      "You need to input \n email address and password \nto create a new account";
    return;
  }
  wait.value = true;
  console.log("creating account");
  firebase
    .auth()
    .createUserWithEmailAndPassword(email.value, password.value)
    .then(function (x) {
      let user = x.user;
      onReceivedFirebaseUser(user);
    })
    .catch(function (err) {
      console.log(err);
      error.value = err.message;
      wait.value = false;
      // Handle errors
    });
}

async function loginWithEmail() {
  if (isDisabled.value) {
    error.value =
      "You need to input \nnpm i @google-cloud/text-to-speechemail address and password to login";
    return;
  }
  wait.value = true;
  firebase
    .auth()
    .signInWithEmailAndPassword(email.value, password.value)
    .then(function (userCredential) {
      var user = userCredential.user;
      onReceivedFirebaseUser(user);
    })
    .catch(function (e) {
      error.value = e.message;
      wait.value = false;
    });
}
async function loginWithGoogle() {
  wait.value = true;

  const provider = new firebase.auth.GoogleAuthProvider();
  firebase
    .auth()
    .signInWithPopup(provider)

    .then(function (result) {
      const user = result.user;
      onReceivedFirebaseUser(user);
    })
    .catch((e) => {
      console.log(e);
      error.value = e.message;
      wait.value = false;
    });
}
async function onReceivedFirebaseUser(user: any) {
  let token = await user.getIdToken();
  console.log("token: " + token);
  await onReceivedToken(token);
}
async function onReceivedToken(firebaseToken: string) {
  console.log("token rec:" + firebaseToken);
  let request = {
    token: firebaseToken,
  };
  let user = await post("login/firebase", request);

  console.log("user:" + JSON.stringify(user));
  if (user != undefined && user?.user?.ID != undefined) {
    store.commit("onLogin", user);
    router.push("/add");

    gtag.event("login-with-firebase", { method: "Google" });
  }
}

const isDisabled = computed(() => {
  if (email.value == "") return true;
  if (password.value == "") return true;
  return false;
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, [
        _createVNode(_component_font_awesome_icon, {
          icon: "bolt",
          class: "mr-4"
        }),
        _hoisted_4
      ]),
      (wait.value)
        ? (_openBlock(), _createBlock(Loading, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            (error.value)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "bg-error text-white p-2 rounded",
                  "data-aos": "fade-in",
                  innerHTML: _unref(errorHtml)
                }, null, 8, _hoisted_8))
              : _createCommentVNode("", true),
            _hoisted_9,
            _createElementVNode("p", _hoisted_10, [
              _createVNode(_component_font_awesome_icon, {
                icon: "envelope-open",
                class: "mr-2"
              }),
              _hoisted_11
            ]),
            _createVNode(MyInput, {
              value: email.value,
              type: "email",
              onInputText: _cache[0] || (_cache[0] = (x) => (email.value = x))
            }, null, 8, ["value"]),
            _createElementVNode("p", _hoisted_12, [
              _createVNode(_component_font_awesome_icon, {
                icon: "key",
                class: "mr-2"
              }),
              _hoisted_13
            ]),
            _createVNode(MyInput, {
              value: password.value,
              onInputText: _cache[1] || (_cache[1] = (x) => (password.value = x)),
              type: "password"
            }, null, 8, ["value"]),
            _createVNode(MyButton, {
              onClickButton: _cache[2] || (_cache[2] = ($event: any) => (loginWithEmail()))
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            }),
            _createVNode(MyButton, {
              onClickButton: _cache[3] || (_cache[3] = ($event: any) => (createAccount()))
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            }),
            _hoisted_16,
            _createVNode(MyButton, {
              onClickButton: _cache[4] || (_cache[4] = ($event: any) => (loginWithGoogle()))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: ['fab', 'google'],
                    size: "lg"
                  }),
                  _hoisted_18
                ])
              ]),
              _: 1
            })
          ]))
    ])
  ]))
}
}

})